<div class="seccion-media">
  <div id="fileTree">
    <app-node [node]="root" (selectedChildren)="processNodeOperation($event)"></app-node>
    <div class="file-tree-actions">
      <span class="over-size" (click)="agregarDirectorio(root)">+</span>
    </div>
  </div>
</div>